import { Col, Container, Row, Button } from "react-bootstrap";

const Intro = () => {
  return (
    <div className="intro">
      <Container className="text-yellow d-flex text-center justify-content-center align-items-center">
        <Row>
          <Col>
            <div className="title">NONTON ANIME</div>
            <div className="title">MARATON SEPUASNYA</div>
            <div className="introButton mt-4 text-center">
              <Button variant="dark" href="#Trending">
                Lihat Semua List
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Intro;
